function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { ignoreError } from "../../infra/utils";
export const useGtm = () => {
  const sendDataToGTM = useGTMDispatch();
  return useMemo(() => ({
    sendEventDeprecated(eventName, eventData) {
      ignoreError(() => {
        sendDataToGTM({
          event_data: null
        }); //clear previous event_data
        sendDataToGTM({
          event: eventName,
          event_data: eventData
        });
      });
    },
    report(eventType, label, data) {
      ignoreError(() => {
        const eventNameWithProperties = getEventNameWithProperties(eventType, label);
        const eventDataWithProperties = getEventDataWithProperties(eventType, label, data);
        sendDataToGTM({
          event_data: null
        }); //clear previous event_data
        sendDataToGTM({
          event: eventNameWithProperties,
          event_data: eventDataWithProperties
        });
      });
    },
    sendPageView(url, eventData) {
      ignoreError(() => {
        sendDataToGTM({
          view_data: null,
          event_data: null
        }); //clear both previous view_data and event_data
        sendDataToGTM({
          event: 'view',
          view_data: eventData
        });
      });
    }
  }), []);
};
const getEventNameWithProperties = (eventType, label) => "".concat(eventType, "-").concat(label);
const getEventDataWithProperties = (eventType, label, data) => {
  const [category, action] = eventType.split('-');
  const eventDataWithProperties = _objectSpread(_objectSpread({}, data), {}, {
    event_category: category,
    event_action: action,
    event_label: label
  });
  return eventDataWithProperties;
};